/** Matches backend `TerminalType` (byte) on DistanceInformation.TerminalList.Type. */
export enum TerminalType {
 AirPort = 1,
 RailWay = 2,
 BusStation = 3,
 HolyShrine = 4,
 MetroLine = 5,
 Custom = 6,
}

export const TERMINAL_TYPE_NAMES: Record<TerminalType, string> = {
 [TerminalType.AirPort]: 'فرودگاه',
 [TerminalType.RailWay]: 'راه آهن',
 [TerminalType.BusStation]: 'پایانه مسافربری',
 [TerminalType.HolyShrine]: 'حرم',
 [TerminalType.MetroLine]: 'خط مترو',
 [TerminalType.Custom]: 'مبدأ دلخواه',
};

const TERMINAL_TYPE_BY_NAME: Record<string, TerminalType> = {
 airport: TerminalType.AirPort,
 railway: TerminalType.RailWay,
 busstation: TerminalType.BusStation,
 holyshrine: TerminalType.HolyShrine,
 metroline: TerminalType.MetroLine,
 custom: TerminalType.Custom,
};

export function getTerminalTypeName(id: TerminalType | number): string {
 return TERMINAL_TYPE_NAMES[id as TerminalType] ?? '';
}

/** Accepts numeric API values (`"4"`) and legacy string names (`"HolyShrine"`). */
export function parseTerminalType(type: string | number | null | undefined): TerminalType | undefined {
 const numeric = Number(type);
 if (Number.isInteger(numeric) && numeric in TERMINAL_TYPE_NAMES) {
  return numeric as TerminalType;
 }

 const key = String(type ?? '')
  .toLowerCase()
  .replace(/[^a-z]/g, '');
 return TERMINAL_TYPE_BY_NAME[key];
}
